import useCallApi from '../../utilities/axios'

import { GetProjectResultType as PublicProjectInfo } from '../web/types/responseWebServiceTypes'

const baseUrl = process.env.REACT_APP_CU_IRB_API_URL

export interface PublicProjectInfoQuery {
    token: string
}

export interface AdvisorVerifyProjectRequest {
    token: string
    projectID: number
    submittedID: number
    isApproved: boolean
    remark: string
}

const useSubmissionApproval = () => {
    const callApi = useCallApi()

    const getPublicProjectInfo = async (projectId: string, submittedId: string, params: PublicProjectInfoQuery) => {
        const { data } = await callApi.axiosGet<{
            message: string
            status: number
            result: PublicProjectInfo
        }>({
            url: `${baseUrl}/public-project/information/${projectId}/${submittedId}`,
            config: { params },
        })

        return data
    }

    async function advisorVerifyProject(params: AdvisorVerifyProjectRequest) {
        const { data } = await callApi.axiosPut<{
            message: string
            status: number
            result: string
        }>({
            url: `${baseUrl}/public-project/advisorVerifyProject`,
            params,
        })

        return data
    }

    return {
        getPublicProjectInfo,
        advisorVerifyProject,
    }
}

export default useSubmissionApproval
